import { CardOnFileFormJustifi } from '../../../components/card-on-file/form/form-justifi';
import { CardOnFileFormStripe } from '../../../components/card-on-file/form/form-stripe';
import { ContextToProps } from '../context-to-props';

export const CardOnFileDefaultForm = () => {
  return <ContextToProps.Form justifiComponent={CardOnFileFormJustifi} stripeComponent={CardOnFileFormStripe} />;
};
